const initialState = {
	"avisoSC": true,
	"notificaciones": [],
	"autos": [],
	"gm": [],
	"vida": [],
	"danios": [],
	"ts": 0,
	"poliza": {
		"generales": {
			"cveEstatu": "",
			"cveRamo": ""
		}
	},
	"edocuenta": [],
	"recibos": [],
	"finiquitos": [],
	"polizaSeleccionada": "",
	"polizasCargadas": false,
	"recibo": {},
	"listaFacturas":[],
	"ramoActual": "",
	"verDetalleMovil": false,
	"touchId": false,
	"callTs": 0,
	"polizaValida": false,
	"mostrarCertificado": false,
	"inactividad": 1200000, //1200000 - 20 minutos
	'pagoPorKilometro': false,
	'detallePagoPorKilometro': {},
	"BeneficiosDentalia":[],
	"TratamientoDentalia":[],
	"SumaDentalia":[],
	"PermisoDentalia":[]
	
};

export function polizasRdc(state = initialState, action) {
	switch (action.type) {
	case "LLENAR_MASCOTA": 
		return {
			...state,
			"poliza": {
				...state.poliza,
				...action.mascota
			}
		};
	case "POLIZAS_LLENAR":
		return {...state,
			"autos": action.autos,
			"gm": action.gm,
			"vida": action.vida,
			"danios": action.danios,
			"ts": action.ts,
			"polizasCargadas": (action.ts == 0) ? false : true,
			"callTs": (new Date()).getTime()
		};
	case "POLIZAS_LIMPIAR":
		return {...initialState};
	case "SET_POLIZA_VALIDA":
		return {...state,
			"polizaValida": action.valida
		};
	case "SET_MOSTRAR_CERTIFICADO":
		return {...state,
			"mostrarCertificado": action.mostrar
		};
	case "POLIZAS_LLENAR_DETALLE":
		return {...state,
			"detalle": action.detalle
		};
	case "NOTIFICACIONES_LLENAR":
		return {...state,
			"notificaciones": action.notificaciones
		};
	case "SET_POLIZA_SELECCIONADA":
		return {...state,
			"polizaSeleccionada": action.polizaSeleccionada
		};
	case "SET_DETALLE_POLIZA":
		return {...state,
			"poliza": action.poliza
		};
	case "LIMPIAR_DETALLE_POLIZA":
		return {...state,
			"poliza": {
				"generales": {
					"cveEstatu": "",
					"cveRamo": ""
				}
			}
		};
	case "SET_POLIZA_RAMO":
		return {...state,
			"poliza": {
				"generales": {
					"cveEstatu": "",
					"cveRamo": action.cveRamo
				}
			}
		};
	case "SET_RECIBO_PAGAR":
		return {...state,
			"recibo": action.recibo
		};
	case "SET_LISTA_FACTURAS":
		return {...state,
			"listaFacturas": action.listaFacturas
		};
	case "SET_LIGA_DESCARGA_FACTURAS":
		return {...state,
			"linkDescargaFactura": action.linkDescargaFactura
		};
	case "SET_RAMO_ACTUAL":
	  return {...state,
			"ramoActual": action.ramoActual
		};
	case "VER_DETALLE_MOVIL":
		return {...state,
			"touchId": action.touchId,
			"verDetalleMovil": true
		};
	case "REINICIAR_CONTADOR_DETALLE_MOVIL":
		return {...state,
			"callTs": (new Date()).getTime()
		};
	case "CERRAR_DETALLE_MOVIL":
		return {...state,
			"verDetalleMovil": false
		};
		////////////////////////////////////////////// DESACTIVAR PAGOS
	case "POLIZAS_PAGO_LLENAR_AUTOS":
		return {...state,
			"autos": action.autos
		};
	case "POLIZAS_PAGO_LLENAR_GMM":
		return {...state,
			"gm": action.gm
		};
	case "POLIZAS_PAGO_LLENAR_VIDA":
		return {...state,
			"vida": action.vida
		};
	case "POLIZAS_PAGO_LLENAR_DANIOS":
		return {...state,
			"danios": action.danios
		};
		////////////////////////////////////////////// DESACTIVAR PAGOS
	case "RECIBOS_LLENAR": 
		return {...state,
			"recibos": action.recibos
		};
	case "RECIBOS_LIMPIAR": 
		return {...state,
			"recibos": []
		};
	case "EDOCUENTA_LLENAR": 
		return {...state,
			"edocuenta": action.edocuenta
		};
	case "EDOCUENTA_LIMPIAR": 
		return {...state,
			"edocuenta": []
		};
	case "FINIQUITOS_LLENAR":
		var array = [];
		if(action.finiquitos && action.finiquitos.length > 0){
			action.finiquitos.map((item, i) => {
				if(item.subtipoDocumento == 595 || item.subtipoDocumento == 596 || item.subtipoDocumento == 597){
					array.push(item);
				}
			});
		}
		
		return {...state,
			"finiquitos": array
		};
	case "FINIQUITOS_LIMPIAR":
		return {...state,
			"finiquitos": []
		};
	case "HOME_SET_EVENT":
		return {...state,
			"evento": action.evento
		};
	case "SET_AVISO":
		return {...state,
			"avisoSC": action.avisosc
		};
	case "SET_PXK":
		return {
			...state,
			pagoPorKilometro: action.pagoPorKilometro
		}
	case 'SET_PXK_DETAIL':
		return {
			...state,
			detallePagoPorKilometro: action.detallePagoPorKilometro
		}
	case 'DENTALIA_TRATAMIENTO':
		return{...state,
				"TratamientoDentalia":action.TratamientoDentalia
			}
	case 'DENTALIA_BENEFICIO':
		return{...state,
				"BeneficiosDentalia":action.BeneficiosDentalia
		}
/* 	case 'DENTALIA_SUMA':
			return{...state,
					"SumaDentalia": action.SumaDentalia
				}*/	
	case 'DENTALIA_PERMISO_DENTAL':
			return{...state,
				"PermisoDentalia": action.PermisoAsis
			}								
	
	default:
		return state;
	}
}



// WEBPACK FOOTER //
// ./src/home/reducer.js